import qs, { ParsedQs } from 'qs';

export function parseSearchParamsFromUrl(url: URL): ParsedQs {
  try {
    return qs.parse(url.search, { ignoreQueryPrefix: true });
  } catch {
    return {};
  }
}
